import './css/HomePageView.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import {
  deleteDocument,
  downloadPdf,
  getDocumentList,
  getStatesList,
  openDocumentById,
  startLoading,
  stopLoading,
  cloneDocument
} from '../../actions/actions';
import { getOrdersList, placeOrder, hideOrderModal} from '../../actions/orderActions';
import SuccessModal from '../../components/Modals/SuccessModal';
import { Tab, Tabs } from '../../components/Tabs';
import {
  IDocument,
  IOrder,
  IOrderStatus,
  IUserData,
  IUserDownloadList,
  IState,
  IEditorState,
  IDisclaimer,
  IDivider,
  IOrderQuantities_Addresses,
} from '../../infrastructure/interfaces';
import { TooltipCont } from '../../infrastructure/tooltips';
import DocumentService from '../../services/DocumentService';
import DeleteConfirmModal from '../Modals/DeleteConfirmModal';
import ShippingInfoWarningModal from '../Modals/ShippingInfoWarningModal';
import CloneDocumentModal from '../Modals/ClonedDocumentModal/CloneDocumentModal';
import WarningModal from '../Modals/WarningModal/WarningModal';
import DocumentsTable from './components/DocumentsTable';
import OrdersTable from './components/OrdersTable';
import { DropdownMenu } from '../DropdownMenu';
import BatchDownloads from "../BatchDownloads/BatchDownloads";
import PDFDownloadModal from '../Modals/PDFDownloadModal/PDFDownloadModal';

export interface IHomePageProps {
  openDocumentById(id: number, redirect?: string): void;
  getDocumentList(userID: string): void;
  getOrdersList(userID: string): void;
  getStatesList(): void;
  deleteDocument(id: number): void;
  onDownload(document: IDocument, dividers: IDivider[], disclaimers: IDisclaimer[], userData: IUserData, isPrintDownload: boolean): void;
  userData: IUserData;
  currentDocument: IDocument | null;
  documentList: any[];
  ordersList: IOrder[];
  orderStatuses: IOrderStatus[];
  dividers: IDivider[];
  disclaimers: IDisclaimer[];
  startLoading(): void;
  stopLoading(): void;
  placeOrder(document: IDocument, user_id: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]): void;
  userDownloadList: IUserDownloadList[];
  statesList: IState[];
  editor: IEditorState;
  orderCreated: boolean;
  hideOrderModal(): void;
  onCloneDocument(document: IDocument, name: string, user_id: string): void;

}

export interface IHomePageState {
  currentTab: number;
  showDeleteDocumentModal: boolean;
  showDeleteWarning: boolean;
  showShippingInfoWarning: boolean;
  editingDocument: IDocument | null;
  selectedOrder: IOrder | null;
  showCloneProject: boolean;
  showPagesQuantityWarning: boolean;
  pagesError: boolean;
  dividersError: string[];
  deleteDocumentID: number;
  documentToDownload: IDocument | null;
}

const mapStateToProps = (state: any): any => {
  return {
    userData: state.user.data,
    currentDocument: state.document,
    editor: state.editor,
    disclaimers: state.wizard.disclaimers,
    dividers: state.wizard.dividers,
    documentList: state.documentList,
    orderCreated: state.orderCreated,
    ordersList: state.ordersList,
    orderStatuses: state.options.statuses,
    userDownloadList: state.userDownloadList,
    statesList: state.statesList,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    openDocumentById: (id: string, redirect?: string) => {
      dispatch(openDocumentById(id, redirect));
    },
    getDocumentList: (userID: string) => {
      dispatch(getDocumentList(userID));
    },
    onCloneDocument: (document: IDocument, name: string, userID: string) => {
      dispatch(cloneDocument(document, name, userID));
    },
    getStatesList: () => {
      dispatch(getStatesList());
    },
    getOrdersList: (userID: string) => {
      dispatch(getOrdersList(userID));
    },
    deleteDocument: (id: number) => {
      dispatch(deleteDocument(id));
    },
    onDownload: (document: IDocument, dividers: IDivider[], disclaimers: IDisclaimer[], userData: IUserData, isPrintDownload: boolean) => {
      dispatch(downloadPdf(document, dividers, disclaimers, userData, isPrintDownload));
    },
    startLoading: () => dispatch(startLoading()),
    stopLoading: () => dispatch(stopLoading()),
    placeOrder: (document: IDocument, user_id: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
        dispatch(placeOrder(document, user_id, user_email, username, comments, orderQuantitiesAddresses));
    },
    hideOrderModal: () => {
        dispatch(hideOrderModal());
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class HomePageView extends React.Component<IHomePageProps, IHomePageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentTab: 0,
      showDeleteDocumentModal: false,
      showDeleteWarning: false,
      showShippingInfoWarning: false,
      editingDocument: null,
      selectedOrder: null,
      showCloneProject: false,
      showPagesQuantityWarning: false,
      pagesError: false,
      dividersError: [],
      deleteDocumentID: -1,
      documentToDownload: null
    };
    this.onDeleteDocument = this.onDeleteDocument.bind(this)
    this.isUnderConstruction = false;
  }

  componentDidMount() {
    this.props.getDocumentList(this.props.userData.id);
    this.props.getStatesList();
    this.props.getOrdersList(this.props.userData.id);
    const tab = window.location.search.split('=')[1];
    if (tab) {
      this.setState({
        currentTab: +tab,
      });
    }
  }

  changeTab = (tab: number) => this.setState({ currentTab: tab });

  editDocument = (documentId: number) => {
    this.props.openDocumentById(documentId, '/Editor');
  }

  onDownload = (document: IDocument) => {
    this.setState({ documentToDownload: document });
  }

  onCloneDocumentLocal = (document: IDocument | null, name: string) => {
    if (document !== null){
      this.props.onCloneDocument(document, name, this.props.userData.id)
    }
  }

  onSubmit = (cloneProjectName: string, formData: FormData) => {
    return false
  }

  onDownloadPDFWithCropMarks = (isPrintDownload: boolean) => {
    const document = this.state.documentToDownload;
    if (document) {
      const validationResult = DocumentService.validateDocument(document);
      if (validationResult.errors === true) {
        const { pagesError, dividersError } = validationResult;
        this.setState({
          showPagesQuantityWarning: true,
          editingDocument: document,
          pagesError,
          dividersError,
        });
        return;
      }

      this.props.onDownload(document, this.props.dividers, this.props.disclaimers, this.props.userData, isPrintDownload);
      this.setState({ documentToDownload: null });
    }
  }

  private isUnderConstruction: boolean;

  onDeleteDocument(id: number) {
    if ((this.props.currentDocument != null) && (this.props.currentDocument.id === id)) {
      this.setState({ showDeleteWarning: true });
      return;
    }

    this.setState({
        showDeleteDocumentModal: true,
        deleteDocumentID: id
    });
  }

  onClose = () => {
    this.setState({
      showPagesQuantityWarning: false,
      showDeleteDocumentModal: false,
      showDeleteWarning: false,
      pagesError: false,
      dividersError: [],
      documentToDownload: null
    });
  }

  onSaveDocument = (document: IDocument, userID: string) => {
    DocumentService.saveDocument(document, userID);
  }
  onOpenOrdersPreview = (document: IDocument) => {
    const validationResult = DocumentService.validateDocument(document);
    if (validationResult.errors === true) {
      const { pagesError, dividersError } = validationResult;
      this.setState({
        showPagesQuantityWarning: true,
        editingDocument: document,
        pagesError,
        dividersError,
      });
      return;
    }
    this.setState({ showShippingInfoWarning: true, editingDocument: document });
  }

  onOpenCloneProject = (document: IDocument) => {
    this.setState({ showCloneProject: true, editingDocument: document});
  }

  onOrderSubmit = (document: IDocument, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
    const validationResult = DocumentService.validateDocument(document);
    if (validationResult.errors === true) {
      const { pagesError, dividersError } = validationResult;
      this.setState({
        showPagesQuantityWarning: true,
        editingDocument: document,
        pagesError,
        dividersError,
      });
      return;
    }

    this.setState({ showShippingInfoWarning: false, editingDocument: null});
    this.props.startLoading();

    DocumentService
      .saveDocument(document, this.props.userData.id)
      .then(() => {
        this.props.placeOrder(document, this.props.userData.id, this.props.userData.email, this.props.userData.username, comments, orderQuantitiesAddresses);
      })
      .catch(error => console.error(error));
  }

  renderHeader() {
    const {
      currentDocument,
      editor,
    } = this.props;

    return (
        <div className="header-container">
          <img src={require('./img/Loveland_logo.svg')} className="loveland-logo" />
          <div className="header-container-right">
            <div className="button-container">
              {(currentDocument && editor.selectedPage) &&
              <Route
                  render={({ history }) => {
                    return (
                        <button className="btn primary-blue large" onClick={() => history.push('/Editor')} title={TooltipCont.TO_EDITING}>
                          Go Back to Editing
                        </button>
                    );
                  }}
              />}
              <Route
                  render={({ history }) => {
                    return this.isUnderConstruction
                    ? (
                        <div></div>
                      )
                    : (
                        <button
                            className="btn primary-green large"
                            onClick={() => history.push('/LandingPage')}
                            title={TooltipCont.CREATE_DOCUMENT}
                        >
                          Create New Project
                        </button>
                      );
                  }}
              />
            </div>
            <DropdownMenu
                title={<img src={require('../Admin/img/admin.svg')} className="admin-logo" />}
                options={[{
                  title: 'Logout',
                  onClick: () => window.location.pathname = '/auth/logout',
                }]}
            />
          </div>
        </div>
    );
  }

  renderDocumentsTab() {
    const {
      currentDocument,
      documentList,
      userData,
      userDownloadList,
      editor,
    } = this.props;

    return (
    <Tab title="Manage Projects">
      <DocumentsTable
          documents={documentList}
          documentInProgress={currentDocument}
          editor={editor}
          onEditDocument={this.editDocument}
          onDeleteDocument={this.onDeleteDocument}
          onDownload={ this.onDownload }
          onOpenOrdersPreview={this.onOpenOrdersPreview}
          onOpenCloneProject={this.onOpenCloneProject}
          userData={userData}
          userDownloadList={userDownloadList}
      />
    </Tab>
    );
  }

  renderOrdersTab() {
    const {
      ordersList,
      orderStatuses,
      userDownloadList,
    } = this.props;

    return (
        <Tab title="Orders">
          <OrdersTable
              orders={ordersList}
              orderStatuses={orderStatuses}
              onDownload={ this.onDownload }
              userDownloadList={userDownloadList}
              showShippingInfo={(doc: IDocument, order: IOrder) =>
                  this.setState({
                    editingDocument: doc,
                    selectedOrder: order })
              }
          />
        </Tab>
    );
  }

  public renderBatchDownloads() {
    return (
        <Tab title="Batch Downloads">
          <BatchDownloads/>
        </Tab>
    );
  }

  renderTabs() {
    return this.isUnderConstruction
    ? (
        <div className="under-construction-wrapper">
            <div className="under-construction-header">
                <div className="under-construction-headline">Under Construction</div>
                <div className="optionText">Loveland Guide Builder is undergoing maintenance. Check back soon.</div>
            </div>
        </div>
    )
    : (
        <Tabs
            tabsContainerClassName="home-page-tab-wrapper"
            tabBodyClassName="home-page-tab-body"
            tabClassName="home-page-tab"
            activeTabClassName="home-page-tab-active"
            currentTab={this.state.currentTab}
            onTabChanged={this.changeTab}
        >
          {this.renderDocumentsTab()}
          {this.renderOrdersTab()}
          {this.renderBatchDownloads()}
        </Tabs>
    );
  }

  renderModals() {
    const {
      deleteDocument,
      orderCreated,
      statesList,
    } = this.props;

    return(<div>
          <PDFDownloadModal
              show={ (this.state.documentToDownload != null) }
              onClose={ this.onClose }
              onDownload={ this.onDownloadPDFWithCropMarks }
          />

          <WarningModal
              show={this.state.showDeleteWarning}
              warningMessage="You can't delete editing document."
              onClose={this.onClose}
          />
          <DeleteConfirmModal
              show={this.state.showDeleteDocumentModal}
              onClose={this.onClose}
              onSave={() => {
                if (this.state.deleteDocumentID >= 0) {
                  deleteDocument(this.state.deleteDocumentID)
                }
                this.onClose();
              }}
              title="Delete this document?"
          />
          <SuccessModal
              show={orderCreated}
              onClose={() => this.props.hideOrderModal()}
              title={'Thank you for your order.'}
              successMessage={<span>All orders will be received within 14 Business Days.</span>}
          />
          <ShippingInfoWarningModal
              document={this.state.editingDocument}
              userData={this.props.userData}
              show={this.state.editingDocument && this.state.showShippingInfoWarning}
              onClose={() => this.setState({ showShippingInfoWarning: false, editingDocument: null })}
              onPlaceOrder={this.onOrderSubmit}
              valid={true}
              statesList={statesList}
          />
          <CloneDocumentModal
            show={this.state.showCloneProject}
            onCloneDocument={(name: string) => {
              this.setState({ showCloneProject: false})
              this.onCloneDocumentLocal(this.state.editingDocument, name)
            }}
            onClose={() => this.setState({ showCloneProject: false })}
          />
        </div>
    );
  }

  render() {
    return (
      <div className="root-container">
        {this.renderHeader()}
        <div className="home-container">
          {this.renderTabs()}
        </div>
        {this.renderModals()}
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/HomePageView.tsx